/* eslint-disable import/prefer-default-export */
import {
  shape,
  string,
  arrayOf,
  number,
} from 'prop-types';

const loadShape = shape({
  loadId: string,
  customerName: string,
  carrierName: string,
  carrierRepName: string,
  originCity: string,
  originState: string,
  destinationCity: string,
  destinationState: string,
  status: string,
  visibilityAppName: string,
  visibilityAppStatus: string,
  problems: arrayOf(string),
  originPickupDate: string,
  destinationDropOffDate: string,
  lastHumanTrackDate: string,
  numberOfStops: number,
});

export default loadShape;
